/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  FileApiResource,
  FileUploadRequest,
  NotFoundErrorResponse,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getAppFileGetResponse302 = {
  data: void
  status: 302
}

export type getAppFileGetResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getAppFileGetResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getAppFileGetResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
;
export type getAppFileGetResponseError = (getAppFileGetResponse302 | getAppFileGetResponse401 | getAppFileGetResponse403 | getAppFileGetResponse404) & {
  headers: Headers;
};

export type getAppFileGetResponse = (getAppFileGetResponseError)

export const getGetAppFileGetUrl = (uuid: string,
    extension: string,) => {


  

  return `/api/files/get/${uuid}.${extension}`
}

export const getAppFileGet = async (uuid: string,
    extension: string, options?: RequestInit): Promise<getAppFileGetResponse> => {
  
  return customFetch<getAppFileGetResponse>(getGetAppFileGetUrl(uuid,extension),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getAppFileDownloadResponse302 = {
  data: void
  status: 302
}

export type getAppFileDownloadResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getAppFileDownloadResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getAppFileDownloadResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
;
export type getAppFileDownloadResponseError = (getAppFileDownloadResponse302 | getAppFileDownloadResponse401 | getAppFileDownloadResponse403 | getAppFileDownloadResponse404) & {
  headers: Headers;
};

export type getAppFileDownloadResponse = (getAppFileDownloadResponseError)

export const getGetAppFileDownloadUrl = (uuid: string,
    extension: string,) => {


  

  return `/api/files/download/${uuid}.${extension}`
}

export const getAppFileDownload = async (uuid: string,
    extension: string, options?: RequestInit): Promise<getAppFileDownloadResponse> => {
  
  return customFetch<getAppFileDownloadResponse>(getGetAppFileDownloadUrl(uuid,extension),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiFileUploadResponse201 = {
  data: FileApiResource
  status: 201
}

export type postApiFileUploadResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiFileUploadResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiFileUploadResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type postApiFileUploadResponseSuccess = (postApiFileUploadResponse201) & {
  headers: Headers;
};
export type postApiFileUploadResponseError = (postApiFileUploadResponse400 | postApiFileUploadResponse401 | postApiFileUploadResponse403) & {
  headers: Headers;
};

export type postApiFileUploadResponse = (postApiFileUploadResponseSuccess | postApiFileUploadResponseError)

export const getPostApiFileUploadUrl = () => {


  

  return `/api/files`
}

export const postApiFileUpload = async (fileUploadRequest: FileUploadRequest, options?: RequestInit): Promise<postApiFileUploadResponse> => {
    const formData = new FormData();
formData.append(`file`, fileUploadRequest.file)
formData.append(`type`, fileUploadRequest.type)

  return customFetch<postApiFileUploadResponse>(getPostApiFileUploadUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}


